export const checkNewRelicIsEnabled = () => {
  return typeof window?.newrelic?.setCustomAttribute === "function";
};
